require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-37-of-the-biggest-brands-on-shopify.json") })
        }
      }, "path---blog-37-of-the-biggest-brands-on-shopify");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-37-of-the-biggest-brands-on-shopify!./.cache/json/blog-37-of-the-biggest-brands-on-shopify.json
// module id = 394
// module chunks = 231608221292675